// extracted by mini-css-extract-plugin
export var actions = "bS_fH";
export var articleMultipleChoiceCTA = "bS_fV";
export var body = "bS_fX";
export var bodyContainer = "bS_fW";
export var illustration = "bS_fZ";
export var selected = "bS_f2";
export var subtitle = "bS_f1";
export var textContent = "bS_f0";
export var tile = "bS_fY";
export var wrapper = "bS_bZ";